import { createTokens, isWeb } from "@tamagui/core";
import * as buttonTokens from "../Button/Button.tokens";
import * as calloutTokens from "../Callout/Callout.tokens";
import * as iconTokens from "../Icon/Icon.tokens";
import { spaceTokens } from "../Layout/space.tokens";
import * as typographyTokens from "../Typography/Typography.tokens";
import { colors } from "./colors.mjs";
const tokens = createTokens({
  color: {
    ...colors,
    ...buttonTokens.colorTokens,
    ...calloutTokens.colorTokens,
    outline: colors["blue.500"]
  },
  radius: {
    ...typographyTokens.linkRadiusTokens,
    ...buttonTokens.radiusTokens,
    ...calloutTokens.radiusTokens,
    // Native does not support dynamic values as border-radius cf https://github.com/react-native-community/discussions-and-proposals/issues/577
    round: isWeb ? "50%" : 9999
  },
  size: {
    ...iconTokens.sizeTokens,
    ...buttonTokens.sizeTokens,
    ...typographyTokens.headerSizeTokens,
    ...typographyTokens.headerLineHeightTokens,
    ...typographyTokens.textSizeTokens,
    ...typographyTokens.textLineHeightTokens
  },
  space: {
    ...typographyTokens.linkSpaceTokens,
    ...calloutTokens.spaceTokens,
    ...buttonTokens.spaceTokens,
    ...spaceTokens
  },
  zIndex: {
    modal: 100
  }
});
export { tokens };